import { Checkbox } from 'antd'
import type { ReactNode } from 'react'
import {
  type StepConfirmDiscard,
  useConfirmDiscard
} from './StepConfirmDiscard'

type StepCheckboxProps = {
  children: ReactNode
  /** Asks before unticking drops what is recorded under the tick. */
  confirmUntick: StepConfirmDiscard
  testId: string
  /** Injected by the form item, or passed by a list of ticks. */
  checked?: boolean
  onChange?: (checked: boolean) => void
}

/** A tick that asks before unticking it drops what is recorded under it. */
const StepCheckbox = ({
  children,
  confirmUntick,
  testId,
  checked,
  onChange
}: StepCheckboxProps) => {
  const { ask, modal } = useConfirmDiscard(confirmUntick, testId)

  return (
    <>
      <Checkbox
        checked={checked}
        data-testid={testId}
        onChange={(event) =>
          event.target.checked ? onChange?.(true) : ask(() => onChange?.(false))
        }
      >
        {children}
      </Checkbox>
      {modal}
    </>
  )
}

export default StepCheckbox
